<template>
<div class="chapter">
<div class="inner_page">
<p class="chaptit"><b>Contents</b></p>
<p class="toc"><a href="#/xhtml/toc1">List of Maps and Sidebars</a></p>
<p class="toc"><a href="#/xhtml/ack">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/cha01">The Great War: An Introduction</a></p>
<p class="toc1">William Manchester</p>
<p class="toc"><a href="#/xhtml/cha02">The Prelude to Conflict</a></p>
<p class="toc"><a href="#/xhtml/cha03">1914</a></p>
<p class="toc"><span href="#/xhtml/cha04" title="Link target outside of Sample">1915</span></p>
<p class="toc"><span href="#/xhtml/cha05" title="Link target outside of Sample">1916</span></p>
<p class="toc"><span href="#/xhtml/cha06" title="Link target outside of Sample">1917</span></p>
<p class="toc"><span href="#/xhtml/cha07" title="Link target outside of Sample">1918</span></p>
<p class="toc"><span href="#/xhtml/cha08" title="Link target outside of Sample">Aftermath</span></p>
<p class="toc"><span href="#/xhtml/cha09" title="Link target outside of Sample">Biographies</span></p>
<p class="toc"><span href="#/xhtml/bib" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3e82aad9